import {GsPublication} from "../../utils/types";
import React, {ReactElement} from "react";
import {Link} from "react-router-dom";
import {Divider, Typography} from "antd";
import { toSafeInnerHTML } from '../../utils/utils';
import Collapsible from "../Collapsible";

import ComponentFromString from "../../utils/ComponentFromString";


interface Props {
    gsPub: GsPublication
}

const GsPublicationDescription = ({gsPub}: Props) => {
    let allAuthors;
    if (gsPub.authors) {
        const authorsArray = gsPub.authors.split(',').map((author: string) => author.trim());
        const authorsCnt = authorsArray.length 
        if (authorsCnt>3) {
            allAuthors = `${authorsArray[0]}, ${authorsArray[1]}, and ${authorsCnt - 2} others`;
        } else {
            allAuthors = gsPub.authors;
        }
    }
    let allInventors;
    if (gsPub.inventors) {
        const inventorsArray = gsPub.inventors.split(',').map((author: string) => author.trim());
        const inventorsCnt = inventorsArray.length 
        if (inventorsCnt>3) {
            allInventors = `${inventorsArray[0]}, ${inventorsArray[1]}, and ${inventorsCnt - 2} others`;
        } else {
            allInventors = gsPub.inventors;
        }

    }

    const isJournalOrConference = gsPub && (gsPub.journal || gsPub.conference)
    const isJournalOrConferenceOrPublisher = gsPub && (gsPub.journal || gsPub.conference || gsPub.publisher)


    const description = gsPub &&  <>
      {gsPub.citationCount && gsPub.citationUrl &&
          <><a href={gsPub.citationUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="sfu-red-link"
          >
            {`Cited by ${gsPub.citationCount}`}
          </a><br /></>}

      {gsPub.source &&
      <span
            dangerouslySetInnerHTML={{ __html: 
              `<strong><em>Source: </em></strong>${toSafeInnerHTML(gsPub.source)} <br />` 
            }}>
      </span>}
      {gsPub.court &&
      <span
            dangerouslySetInnerHTML={{ __html:
              `<strong><em>Court: </em></strong>${toSafeInnerHTML(gsPub.court)} <br />` 
            }}>
      </span>}
      {gsPub.patentOffice &&
      <span
            dangerouslySetInnerHTML={{ __html:
              `<strong><em>Patent Office: </em></strong>${toSafeInnerHTML(gsPub.patentOffice)} <br />`
            }}>
      </span>}
      {gsPub.institution &&
      <span
            dangerouslySetInnerHTML={{ __html:
              `<strong><em>Institution: </em></strong>${toSafeInnerHTML(gsPub.institution)} <br />`
            }}>
      </span>}
      {!isJournalOrConference && gsPub.publisher &&
      <span
            dangerouslySetInnerHTML={{ __html: 
              `<strong><em>Publisher: </em></strong>${toSafeInnerHTML(gsPub.publisher)} <br />`
            }}>
      </span>}

      {gsPub.reportNumber &&
      <span
            dangerouslySetInnerHTML={{ __html: 
              `<strong><em>Report Number: </em></strong>${toSafeInnerHTML(gsPub.reportNumber)} <br />`
            }}>
      </span>}
      {gsPub.applicationNumber &&
      <span
            dangerouslySetInnerHTML={{ __html: 
              `<strong><em>Application Number: </em></strong>${toSafeInnerHTML(gsPub.applicationNumber)} <br />`
            }}>
      </span>}
      {gsPub.docketId &&
      <span
            dangerouslySetInnerHTML={{ __html: 
              `<strong><em>Docket ID: </em></strong>${toSafeInnerHTML(gsPub.docketId)} <br />`
            }}>
      </span>}

      {gsPub.patentNumber &&
      <span
            dangerouslySetInnerHTML={{ __html: 
              `<strong><em>Patent Number: </em></strong>${toSafeInnerHTML(gsPub.patentNumber)} <br />`
            }}>
      </span>}

      {gsPub.conference &&
      <span
            dangerouslySetInnerHTML={{ __html: 
              `<strong><em>Conference: </em></strong>${toSafeInnerHTML(gsPub.conference)} <br />`
            }}>
      </span>}
      {gsPub.journal &&
      <span
            dangerouslySetInnerHTML={{ __html: 
              `<strong><em>Journal: </em></strong>${toSafeInnerHTML(gsPub.journal)} <br />`
            }}>
      </span>}
      {gsPub.book &&
      <span
            dangerouslySetInnerHTML={{ __html: 
              `<strong><em>Book: </em></strong>${toSafeInnerHTML(gsPub.book)} <br />`
            }}>
      </span>}

      {!isJournalOrConferenceOrPublisher && gsPub.issue &&
      <span
            dangerouslySetInnerHTML={{ __html: 
              `<strong><em>Issue: </em></strong>${toSafeInnerHTML(gsPub.issue)} <br />`
            }}>
      </span>}
      {!isJournalOrConferenceOrPublisher && gsPub.pages &&
      <span
            dangerouslySetInnerHTML={{ __html: 
              `<strong><em>Pages: </em></strong>${toSafeInnerHTML(gsPub.pages)} <br />`
            }}>
      </span>}
      {!isJournalOrConferenceOrPublisher && gsPub.volumn &&
      <span
            dangerouslySetInnerHTML={{ __html: 
              `<strong><em>Volumn: </em></strong>${toSafeInnerHTML(gsPub.volumn)} <br />`
            }}>
      </span>}

      {gsPub.publicationDate && <>
      <span>
          <strong>Date</strong>: {gsPub.publicationDate}
      </span><br/></>}
      {gsPub.decidedDate && <>
      <span>
          <strong>Date</strong>: {gsPub.decidedDate}
      </span><br/></>}

      {allAuthors &&
      <span>
          <strong>Authors</strong>: <span style={{ color: '#737CA1' }}>{allAuthors}</span> <br/>
      </span>}
      {allInventors &&
      <span>
          <strong>Inventors</strong>: <span style={{ color: '#737CA1' }}>{allInventors}</span> <br/>
      </span>}

      {gsPub.sfu_authors &&
      <span>
          <strong>SFU faculty authors</strong>: {gsPub.sfu_authors.map(
          (author, index) => (
              <React.Fragment key={index}>
                  <Link to={`/profile/${author.random_id}`}>
                      <span className='gray-link-button'>{author.preferred_last_name}, {author.preferred_first_name && `${author.preferred_first_name[0]}.`}</span>
                  </Link>
                  {index !== gsPub.sfu_authors.length - 1 &&
                  <Divider type='vertical' style={{margin: '0 0.3em'}}/>}
              </React.Fragment>
          )
      )}<br/>
      </span>}


      {/* {gsPub.description &&
      <Typography.Paragraph ellipsis={{rows: 2, expandable: true, symbol: 'more'}}
                            style={{color: 'rgba(0,0,0, 0.45)'}}>
          <strong>Description</strong>: {
          gsPub.description.length>100?
          '... '.concat(gsPub.description.slice(gsPub.description.indexOf('. ') + 2)):
          toSafeInnerHTML(gsPub.description)
          }
      </Typography.Paragraph>} */}

      
      {gsPub.description&&<Collapsible
        maxRowNum={2}
      >
        <strong>Description: </strong>
        {ComponentFromString(gsPub.description)}
      </Collapsible>}
    </>;

    return description as ReactElement;
};

export default GsPublicationDescription;